var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Have You Secured Insurance Coverage?"}},[_c('input-radio-boolean',{attrs:{"name":"has_coverage","true":"Yes","false":"No","read_only":_vm.read_only},model:{value:(_vm.has_coverage),callback:function ($$v) {_vm.has_coverage=$$v},expression:"has_coverage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }